/**
 * @module UI/Utilities/Helpers
 * @desc Helpers helper funtions
 */

/**
 * Return text singular or plural
 */
export function pluralize(quantity: number, singular: string, plural: string) {
  return quantity > 1 ? plural : singular;
}
